import { Button, Col, Form, Icon, Popover, Row, Spin } from "antd"
import { FormComponentProps } from "antd/lib/form"
import autobind from "autobind-decorator"
import React from "react"
import { WithTranslation, withTranslation } from "react-i18next"
import { connect } from "redux-scaffolding-ts"
import { formatMessage } from 'src/core/services/http.service'
import { clone } from "../../core/utils/object"
import { TooltipItem, TooltipStore } from "../../stores/tooltips-store"
import TooltipForm from "./tooltip-form"

interface EditableTooltipProps extends WithTranslation {
  name: string
  editable: boolean
  placement?: string
  visible?: boolean
}

interface EditableTooltipState {
  editing: boolean
  item?: TooltipItem,
  visible: boolean,
  lan: string
}

@connect(["tooltips", TooltipStore])
class EditableTooltip extends React.Component<EditableTooltipProps & FormComponentProps, EditableTooltipState> {
  constructor(props: EditableTooltipProps & FormComponentProps) {
    super(props)
    this.state = {
      editing: false,
      item: undefined,
      visible: false,
      lan: props.i18n.language,
    }
  }

  private get tooltipsStore(): TooltipStore {
    return (this.props as any).tooltips as TooltipStore
  }

  public componentWillMount() {
    this.load()
  }

  public componentDidUpdate(prevProps: EditableTooltipProps) {
    if (this.state.lan != prevProps.i18n.language) {
      this.setState({ lan: prevProps.i18n.language }, () => { this.load() })
    }
  }

  @autobind
  private async load() {
    var result = await this.tooltipsStore.getByName(this.props.name)
    this.setState({ item: result })
  }

  @autobind
  private onSaveItem() {
    return new Promise((resolve, reject) => {
      this.props.form.validateFields(event => {
        var values = this.props.form.getFieldsValue()
        if (!event) {
          return new Promise((resolve1, reject1) => {
            this.handleUpdateItem(values).then(res => {
              this.setState({ editing: false })
              this.props.form.resetFields()
              resolve(res)
            }).catch(error => {
              var parsedError = error && error.response && error.response.data && error.response.data.messages ? error.response.data : {
                isSuccess: false,
                items: [],
                total: 0,
                messages: [{ body: formatMessage(error), level: 'Error' }]
              }
              this.setState({ editing: false })
              reject1(error)
            })
          })
        }
        else
          this.setState({ editing: true })
      })
    })
  }

  @autobind
  private handleUpdateItem(values: any) {
    return new Promise((resolve, reject) => {
      var item = Object.assign(clone(this.state.item), values)
      this.tooltipsStore.update(item)
        .then((res) => { this.setState({ item: item }); resolve(res) })
        .catch(reject)

    })
  }

  @autobind
  private handleClick() {
    this.setState({
      editing: true,
    })
  }

  @autobind
  private renderEditionMode() {
    return (
      <div style={{ maxWidth: 500 }}>
        <Row gutter={24}>
          <Col span={24}>
            <Form
              id="tooltipEditionForm"
              onSubmit={this.onSaveItem}
            >
              <TooltipForm
                item={this.state.item}
                getFieldDecorator={this.props.form.getFieldDecorator}
                onSave={this.onSaveItem}
              />
            </Form>
          </Col>
        </Row>
        <Row style={{ marginTop: 5 }}>
          <Button style={{ float: 'right', margin: 3 }} type="primary" onClick={this.onSaveItem} > {this.props.t("Save")} </Button>
          <Button style={{ float: 'right', margin: 3 }} onClick={() => this.setState({ editing: false })} > {this.props.t("Cancel")} </Button>
        </Row>
      </div>
    )
  }

  @autobind
  private renderTooltipMode() {
    const tooltip = this.state.item
    const tooltipTextUnits = this.props.editable ? 22 : 24
    const tooltipIconUnits = 24 - tooltipTextUnits
    return (
      <div style={{ maxWidth: 500 }}>
        <Row justify="space-around" align="middle">
          <Col
            span={tooltipTextUnits}>
            <p dangerouslySetInnerHTML={{ __html: tooltip ? tooltip.text : "" }}></p>
          </Col>
          {this.props.editable && <Col
            span={tooltipIconUnits}>
            <Icon
              type="edit"
              onClick={this.handleClick}
            />
          </Col>}
        </Row>
      </div>
    )
  }

  @autobind
  private hide() {
    this.setState({ editing: false, visible: false })
  }

  public render() {
    const { placement, children, visible } = this.props
    const tooltip = this.state.item
    const content = !tooltip ? (<Spin />) : (
      <>
        {this.state.editing ? this.renderEditionMode() : this.renderTooltipMode()}
      </>)
    if (visible === undefined) {
      return (
        <Popover
          overlayStyle={{ zIndex: 9999 }}
          content={content}
          onVisibleChange={
            (visible) => (this.setState({ visible: visible, editing: visible ? this.state.editing : false }))
          }
          trigger={this.state.visible && !this.state.editing ? "hover" : this.state.editing ? "click" : "hover"}
          visible={this.state.visible}
          placement={placement ? placement : "topLeft" as any}
          mouseEnterDelay={0.7}
          autoAdjustOverflow
        >
          {children}
        </Popover>
      )
    }
    return (
      <Popover
        overlayStyle={{ zIndex: 9999 }}
        content={content}
        onVisibleChange={
          (visible) => (this.setState({ visible: visible, editing: visible ? this.state.editing : false }))
        }
        trigger={this.state.visible && !this.state.editing ? "hover" : this.state.editing ? "click" : "hover"}
        visible={this.state.visible}
        placement={placement ? placement : "topLeft" as any}
        mouseEnterDelay={0.7}
        autoAdjustOverflow
      >
        {children}
      </Popover>
    )
  }
}

export default withTranslation()(Form.create({})(EditableTooltip) as any) as any as React.ComponentClass<EditableTooltipProps>